import './home.scss';

import React, { useEffect, useState } from 'react';
import { Divider } from 'primereact/divider';
import { getLast3 } from 'app/api/clientNewsApi';
import { useNavigate } from 'react-router-dom';

export const ClientHome = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  useEffect(() => {
    getLast3()
      .then(r => {
        setData(r.data);
      })
      .catch(e => {
        console.error(e);
      });
  }, []);

  const showDetail = item => {
    navigate(`/news/${item.id}`);
  };

  return (
    <div className="container mt-5">
      {/* Main heading */}
      <h1 style={{ color: 'var(--primary-color)', fontWeight: 'bold' }}>NOVINKY</h1>
      <Divider className="client-divider" />

      {/* Cards in a row (Bootstrap columns) */}
      <div className="row">
        {data &&
          data.map((item, index) => (
            <div key={index} className="col-md-4 mb-4">
              {/* Top gold bar + image placeholder */}
              <div style={{ border: `1px solid 'var(--primary-color)'` }}>
                <div style={{ backgroundColor: 'var(--primary-color)', padding: '0.5rem' }}>
                  <h5 className="mb-0 text-white">{item.title}</h5>
                </div>
                <div
                  style={{
                    height: '250px',
                    backgroundColor: '#999',
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                  }}
                >
                  <img
                    style={{
                      maxWidth: '100%',
                      maxHeight: '100%',
                      objectFit: 'contain',
                    }}
                    id="image"
                    className="w-40 sm:w-60rem xl:w-50rem shadow-2 block xl:block mx-auto border-round"
                    src={`https://system.nfagroup.eu/api/client-news/image/${item.imagePath}`}
                    alt={item.imagePath}
                  />
                </div>
              </div>

              {/* Below the image: repeated title, text, and buttons */}
              <h5 style={{ color: 'var(--primary-color)' }} className="mt-3">
                {item.title}
              </h5>
              <p
                style={{
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 5, // Limit to 5 lines
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                <span dangerouslySetInnerHTML={{ __html: item.message }}></span>
              </p>

              {/* Buttons row */}
              <div>
                {/* “viac” button */}
                <button className="btn btn-outline-secondary" type="button" onClick={() => showDetail(item)}>
                  + viac
                </button>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ClientHome;
